export default __webpack_public_path__ + "static/media/picture_home_wtsb.c724e13f.png";